import { useQuery } from 'react-query'

import { fetchContactById } from '@modules-deprecated/app/contacts/query-api'

import { QueryKeys } from '../../../enums/queryKeys'

export const useFetchContact = (contactId?: string | null) => {
  const { data, ...rest } = useQuery([QueryKeys.Contact, contactId], () => fetchContactById(contactId as string), {
    enabled: !!contactId,
  })

  return {
    contact: data?.contact,
    ...rest,
  }
}
